"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyBridge = void 0;
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const utils_1 = require("./utils/utils");
const scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: utils_1.getAccountShape });
exports.currencyBridge = {
    preload: () => Promise.resolve({}),
    hydrate: () => { },
    scanAccounts,
};
//# sourceMappingURL=currency.js.map